export default __webpack_public_path__ + "static/media/facebook.91ede2d9.svg";